import { Flex } from '@teamsparta/stack-flex';
import { Text } from '@teamsparta/stack-text';
import { vars } from '@teamsparta/stack-tokens';

import type { PollOption } from '@/api/community/post';

import { formatPercentage, useCalculatePoll } from './logic';
import * as S from './style';

interface Props {
  pollOptions?: PollOption[];
}

export function DidPoll({ pollOptions }: Props) {
  const { pollOptionsWithPercentage, isMostSelectedOption } =
    useCalculatePoll(pollOptions);

  return (
    <Flex.Column fullWidth gap={6}>
      {pollOptionsWithPercentage.map(
        ({ optionText, selectedCount, percentage }, index) => (
          <Flex.Row
            key={`${optionText}-${index}`}
            fullWidth
            justify='between'
            padding='10px 12px'
            style={{
              position: 'relative',
              overflow: 'hidden',
              border: `1px solid ${
                isMostSelectedOption(optionText)
                  ? 'rgba(255, 92, 92, 0.40)'
                  : vars.neutral[80]
              }`,
              borderRadius: '999px',
            }}
          >
            <Text
              as='span'
              font='captionSb'
              color={vars.neutral[30]}
              style={{ zIndex: 1 }}
            >
              {optionText}
            </Text>
            <Text
              as='span'
              font='captionSb'
              color={
                isMostSelectedOption(optionText)
                  ? vars.brand.strong
                  : vars.neutral[50]
              }
              style={{ zIndex: 1 }}
            >
              {formatPercentage(percentage)} ({selectedCount})
            </Text>
            <S.PollProgressBar
              percentage={percentage}
              isMostSelectedOption={isMostSelectedOption(optionText)}
            />
          </Flex.Row>
        ),
      )}
    </Flex.Column>
  );
}
